import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { useTooltipControllerSharedState } from './useTooltipControllerSharedState';
import { useTooltipControllerOpen } from './useTooltipControllerOpen';
import { useTooltipControllerTouch } from './useTooltipControllerTouch';
export function useTooltipController(props) {
  var children = props.children;
  var childrenRef = React.useRef(null);
  var handleChildrenRef = useForkRef(children.ref, childrenRef);
  var state = useTooltipControllerSharedState();
  var _useTooltipController = useTooltipControllerOpen({
      props: props,
      state: state,
      childrenRef: childrenRef
    }),
    open = _useTooltipController.open,
    handleClose = _useTooltipController.handleClose,
    createHandleEnter = _useTooltipController.createHandleEnter,
    handleLeave = _useTooltipController.handleLeave;
  var handleEnterForward = createHandleEnter(true);
  var _useTooltipController2 = useTooltipControllerTouch({
      props: props,
      state: state,
      handleEnter: handleEnterForward,
      handleClose: handleClose
    }),
    handleTouchStart = _useTooltipController2.handleTouchStart,
    handleTouchEnd = _useTooltipController2.handleTouchEnd;
  var childrenProps = _objectSpread(_objectSpread({}, children.props), {}, {
    onMouseEnter: handleEnterForward,
    onMouseLeave: handleLeave,
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    ref: handleChildrenRef
  });
  return {
    open: open,
    childrenProps: childrenProps,
    tooltipProps: {
      open: open,
      anchorRef: childrenRef,
      onMouseLeave: handleLeave,
      onMouseEnter: createHandleEnter(false)
    }
  };
}